import { checkOPFSWriteSupport } from "@/utils";

import { CatalogStorage } from "./CatalogStorage.types";
import { CatalogStorageDb } from "./CatalogStorageDb";
import { CatalogStorageFs } from "./CatalogStorageFs";

let _catalogStorage: CatalogStorage | null = null;

const _ready = checkOPFSWriteSupport().then((supported) => {
    _catalogStorage = supported
        ? new CatalogStorageFs()
        : new CatalogStorageDb();
});

export const catalogStorage = new Proxy({} as CatalogStorage, {
    get(_target, prop: string) {
        return (...args: unknown[]) =>
            _ready.then(() => {
                if (!(_catalogStorage && prop in _catalogStorage))
                    return undefined;

                const method = _catalogStorage[prop as keyof CatalogStorage];
                if (typeof method === "function") {
                    return (method as (...a: unknown[]) => unknown).apply(
                        _catalogStorage,
                        args,
                    );
                }
                return method;
            });
    },
});
